<template>
  <div class='EnbCheckoutProd01'>
    <div class="x">
      <DeleteIcon @click="Del(data)" color="#CCCCCC"/>
    </div>
    <div class="img">
      <img v-if="data.img.length" :src="api + data.img[0].img">
    </div>
    <div class="desc">
      {{ data.name }}
    </div>
  </div>
</template>

<script>
import api from '@/mixins/api'
import DeleteIcon from '@/components/EnbPainel/Icons/DeleteIcon'
export default {
  name: 'EnbCheckoutProd01',
  components: { DeleteIcon },
  props: ['data'],
  mixins: [api],
  methods: {
    Del (data) {
      this.$emit('DelLike', data)
    }
  }
}
</script>

<style scoped>
.EnbCheckoutProd01 {
  display: flex;
  width: 75%;
}

.x {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 10%;
  cursor: pointer;
  font-weight: bold;
}

.img {
  display: flex;
  justify-content: center;
  align-items: center;
}

img {
  width: 90px;
  height: 90px;
}

.desc {
  display: flex;
  align-items: center;
  padding-left: 2%;
  width: 65%;
  text-align: left;
}

@media (max-width: 500px) {
  img {
    width: 60px;
    height: 60px;
  }
}
</style>
